<template>
    <div class="relative">
        <div class="absolute -mt-1 md:-mt-12 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Sale Concession"
            :no_border="true"
            class="mt-6 md:-mt-2 mb-6"
            label_class="ml-8 md:ml-0"
        >
            <input-money
                class="sm:w-36"
                name="purchase_side_sale_concession"
                :value="value"
                @input="$emit('input', $event)"
                :read_only="read_only"
            />

            <div class="flex flex-1 justify-end items-center mt-6 sm:mt-0 lg:mt-2 md:ml-6">
                <input-radio-boolean
                    name="purchase_side_paid_off_top"
                    v-model="paid_off_top_value"
                    true="Paid Off Top"
                    false="Paid By Agent"
                    :reverse="true"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <div class="border-b border-gray-400 md:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: null },
        commission_detail: { default: () => ({}) },
        read_only: { default: false },
        paid_off_top: {},
    },

    computed: {
        paid_off_top_value: {
            get() {
                return this.paid_off_top;
            },
            set(val) {
                this.$emit('updated', val);
            }
        },
    },
}
</script>
